import actionCreatorFactory, { Action } from 'typescript-fsa';

const actionCreator = actionCreatorFactory('Impressions');

interface ITrackImpressionActionPayload {
  track: GQL.ITrackSearchResult;
}

export type TrackImpressionAction = Action<ITrackImpressionActionPayload>;
export const trackImpression = actionCreator<ITrackImpressionActionPayload>('TRACK');



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/actions/impressions.ts